import React from "react";

import client1 from '../assets/images/web/logo/TCS.jpg'
import client2 from '../assets/images/web/logo/goldman.jpg'
import client3 from '../assets/images/web/logo/infosys.jpg'
import client4 from '../assets/images/web/logo/openlogix.jpg'
import client5 from '../assets/images/web/logo/nttdata.jpg'


export default function Partners(){
    const clientImg = [client1, client2, client3, client4, client5]
    return(
        <div className="row justify-content-center">
            {clientImg.map((item,index)=>{
                return(
                <div className="col-lg-2 col-md-2 col-6 text-center" key={index}>
                    <img src={item} className="img-fluid" alt=""/>
                </div>
                )
            })}
        </div>
    )
}